import { Navigate } from 'react-router-dom'
import { useGlobalState } from '@/stores/globalState'

// Role gate for admin-only routes. UX affordance only — `user` is the
// localStorage-persisted profile and trivially spoofable; the real gate is
// the backend's requireAdmin 403 on every /api/content/admin/* request.
// Renders inside ProtectedRoute, which already handles the unauthenticated
// and profile-syncing states, so by the time children render `user` is the
// synced profile. A missing role (pre-migration persisted user) fails
// closed and self-heals on the next profile sync.
export function AdminRoute({ children }: { children: React.ReactNode }) {
  const user = useGlobalState((s) => s.user)
  if (user?.role !== 'ADMIN') return <Navigate to="/" replace />
  return <>{children}</>
}
